module.exports = __webpack_public_path__ + "static/media/quiz_ribbon.fc49f145.svg";